import { useEffect, useRef, useState } from "react";

export function useConfirmedPharmacySelection(
	value: string | undefined,
	postalCode: string,
) {
	const [confirmedSelection, setConfirmedSelection] = useState<{
		vendorId: string;
		postalCode: string;
	} | null>(() =>
		value && Number.isFinite(Number(value))
			? { vendorId: value, postalCode }
			: null,
	);
	const previousValueRef = useRef(value);
	useEffect(() => {
		const isNumericValue = !!value && Number.isFinite(Number(value));
		if (!isNumericValue) {
			setConfirmedSelection(null);
			previousValueRef.current = value;
			return;
		}
		if (value !== previousValueRef.current) {
			setConfirmedSelection({ vendorId: value, postalCode });
		}
		previousValueRef.current = value;
	}, [postalCode, value]);
	return { confirmedSelection, setConfirmedSelection };
}
